/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { CallbackType, FRCallback, FRStep, MetadataCallback } from "@forgerock/javascript-sdk";
import { IStageProgressBadge } from "../components/layout/StageProgressBadge";

export const getTextOutputCallBackByMessageType=(step:FRStep,messageType:string):any=>{
   let returnCallback:any
    const textOutputCallbacks:FRCallback[]= step.getCallbacksOfType(CallbackType.TextOutputCallback)
   if(textOutputCallbacks.length){
    textOutputCallbacks.forEach((callback:FRCallback)=>{
        if(callback.getOutputByName('messageType','')===messageType)
        returnCallback= callback;
        return;
    })
   }
return returnCallback;
}

export const getStageHeader=(step:FRStep)=>{
    const metadataCallbacks:FRCallback[]= step.getCallbacksOfType(CallbackType.MetadataCallback);
    if(metadataCallbacks.length){
        const metaData=metadataCallbacks[0].getOutputByName('data',{'$stages':{'values':[]}})
        if(!!metaData['$stages'] && !!metaData.$stages.values && metaData.$stages.values.length)
             return metaData.$stages.values;
    }
    return [];
}

export const getInitialStageItems=(step:FRStep,metaStageHeader:{name:string,stageName:string}[]):IStageProgressBadge[]=>{
    let stageItems: IStageProgressBadge[] = [];
    metaStageHeader.forEach((value:any,index:number)=>{
            if(index==0){
                stageItems.push({ className: 'active', stageName: value.name })
            }else{
                stageItems.push({ className: 'disabled', stageName:value.name })
            }
        })
    
    return stageItems;
}

